import componentInitializer from "@/frontend/utils/componentInitializer"
import checkIsMobile from "is-mobile"

function initTopDropdown() {
  const isMobile = checkIsMobile({ tablet: true, featureDetect: true })

  // Go to page instead of dropdown
  $('.btnav__top-dropdown [data-toggle="dropdown"]').on("click", function (e) {
    if (!isMobile) {
      e.preventDefault()

      const path = $(this).prop("href")
      Turbo.visit(path)
    }
  })
}

componentInitializer(initTopDropdown)

function initBurgerSideNav() {
  const mainNavbar = document.getElementById("main-navbar")
  const mainNabvarClasses = ["duration-500", "transition-all"]

  $(".hamburger").removeClass("is-active")

  var $body = $("body"),
    $sidenav = $body.find("> .sidenav"),
    $sidenavOverlay = $body.find("> .sidenav-overlay"),
    touchstartX = 0,
    touchendX = 0,
    threshold = 143
  $body.append($(".modal, .pswp"))

  function onTouchStart(event) {
    touchstartX = event.originalEvent.changedTouches[0].screenX
  }

  function onTouchEnd(event) {
    touchendX = event.originalEvent.changedTouches[0].screenX
    if (touchstartX - touchendX > threshold) closeSidenav()
  }

  function openSidenav() {
    $body.addClass("show-sidenav")
    $(".hamburger").addClass("is-active")
    // Prevent the main navbar transitions
    mainNavbar.classList.remove(...mainNabvarClasses)
    $body.on("touchstart", onTouchStart)
    $body.on("touchend", onTouchEnd)
  }

  function closeSidenav() {
    $body.removeClass("show-sidenav")
    setTimeout(() => {
      // Add the transition classes back to re-enable transitions for scrolling up.
      mainNavbar.classList.add(...mainNabvarClasses)
    }, 200)
    $(".hamburger").removeClass("is-active")
    $body.off("touchstart", onTouchStart)
    $body.off("touchend", onTouchEnd)
  }

  function toggleSidenav() {
    if ($body.hasClass("show-sidenav")) closeSidenav()
    else openSidenav()
  }

  $('[data-toggle="sidenav"]').on("click", function () {
    toggleSidenav()
  })

  $sidenavOverlay.click(function (e) {
    closeSidenav()
    return false
  })

  $sidenav.find(".has-children > a").click(function (e) {
    $(this).parent().toggleClass("active")
    $(this).find("i").toggleClass("fa-chevron-down").toggleClass("fa-chevron-up")
    e.preventDefault()
  })
  $(".see-all").on("click", function (e) {
    e.preventDefault
    $(this).attr("hidden", true)
    $(e.currentTarget.parentNode)
      .find("li")
      .each(function () {
        $(this).removeAttr("hidden")
      })
  })

  const navDropdowns = $(".controlled-dropdown-button")
  const getControlledDropdown = (value) => value.querySelector(".controlled-dropdown")
  const cleanListeners = (value, listener, listenerFunc) => {
    const cleanIntervalListener = () => {
      value.removeEventListener(listener, listenerFunc)
      document.removeEventListener("turbo:before-cache", cleanIntervalListener)
    }
    document.addEventListener("turbo:before-cache", cleanIntervalListener)
  }
  const bindDropdownDelay = (event, value, timeout) => {
    const display = event === "enter" ? "block" : "none"
    const listener = `mouse${event}`
    const listenerFunc = () => {
      clearTimeout(timeout.current)
      timeout.current = setTimeout(() => (getControlledDropdown(value).style.display = display), 500)
    }
    value.addEventListener(listener, listenerFunc)
    cleanListeners(value, listener, listenerFunc)
  }
  const bindDropdownMobileBehaviour = (value) => {
    const listener = `click`
    const listenerFunc = () => {
      getControlledDropdown(value).style.display =
        getControlledDropdown(value).style.display === "block" ? "none" : "block"
    }
    value.addEventListener(listener, listenerFunc)
    cleanListeners(value, listener, listenerFunc)
  }
  navDropdowns.each((_, value) => {
    bindDropdownMobileBehaviour(value)
    let timeout = { current: null }
    bindDropdownDelay("enter", value, timeout)
    bindDropdownDelay("leave", value, timeout)
  })
  function cleanBeforeCache() {
    closeSidenav()
  }
  document.removeEventListener("turbo:before-cache", cleanBeforeCache)
  document.addEventListener("turbo:before-cache", cleanBeforeCache)
}

componentInitializer(() => {
  initBurgerSideNav()
})
